import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/components/molecules/mobile-menu-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/ui/components/views/home/components-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/components/views/home/main-section-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/components/views/home/main-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StarsBackgroundImage"] */ "/vercel/path0/app/ui/components/views/home/stars-background-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsContainer"] */ "/vercel/path0/app/ui/components/views/home/testimonials-container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/ui/navigation/sidenav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
